export const Vignette = () => <div className="cine-vignette" aria-hidden="true" />;
